<template>
    <div class="app-container">
      <div style="margin-bottom: 10px" >
        <el-button type="primary"  @click="newAdd"  :disabled="!isSave" style="margin-left: 4px" 
          >新增</el-button
        >
        <el-button type="primary" @click="openDialog"  v-if="Status === 0" style="margin-left: 4px" 
          >单据选择</el-button
        >
        <el-button type="primary"  v-if="Status === 0" @click="save"  style="margin-left: 4px" 
          >保存</el-button
        >
      </div>
      <el-form
        :model="data"
        ref="form"
        :inline="true"
        :line-form="true"
        label-width="80px"
        status-icon
      >
        <el-row style="margin-top: 18px">
            <el-col :span="8">
            <el-form-item label="返工单号" label-width="100px" prop="DocNo" class="is-required">
              <span
                style="display: inline-block; width: 180px"
                v-if="mode == 0 || Status === 1"
                class="detail-span"
                >{{ data.DocNo }}</span
              >
              <el-input
                style="width: 180px"
                v-else
                v-model="data.DocNo"
                placeholder="请输入返工单号"
              ></el-input>
            </el-form-item>  
          </el-col>
          <el-col :span="8">
            <el-form-item label="单据日期" label-width="100px" prop="DocDate">
                <span class="not-edit" v-if="Status === 1">{{ toDateString(data.DocDate) }}</span>
                <el-date-picker
                    v-else
                    v-model="data.DocDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    placeholder="选择日期"
                    style="width: 180px"
                    @change="(v) => getPreviewNo(v)"
                >
                </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态">
              <span class="not-edit" v-if="Status === 1">{{ data.Status === 0 ? '返工中' : '已完成' }}</span>
              <el-select v-model="Status" v-else>
                <el-option label="返工中" :value="0" key="a1"></el-option>
                <el-option label="已完成" :value="1" key="a2"></el-option>
              </el-select>
             
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-table class="table-line tb-c-head" :data="TestReworkDtsDtos" border >
          <el-table-column label="序号" type="index" min-width="55" show-overflow-tooltip />
          <el-table-column label="商品名称" prop="ProductName" min-width="170" show-overflow-tooltip />
          <el-table-column label="需返工数量" prop="UnReworkQuantity" min-width="150" show-overflow-tooltip />
          <el-table-column label="本次返工数量" prop="ThisReworkQuantity" min-width="150" show-overflow-tooltip />
          <el-table-column label="累计返工数量" prop="ReworkQuantity" min-width="130" />
          <el-table-column label="返工中数量" min-width="130" >
            <template slot-scope="{row}">
              <span>{{ row.UnReworkQuantity - row.ReworkQuantity }}</span>
            </template>

          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="100">
            <template slot-scope="{row}">
              <el-button @click="handleClick(row)" type="text" :disabled="row.TestReworkId === 0" size="small">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
     <list-dialog ref="listDialog" @select="selectList" />
     <qua-dialog ref="quaDialog" @update="update" />

    </div>   

  </template>
<script>


// import iForm from '@/data/sys/user/IForm.json'
import listDialog from '@/components/production/reportmanagement/rework/listDialog'
import quaDialog from '@/components/production/reportmanagement/rework/quaDialog'


export default {
    name: 'editrework',
  components: {
    listDialog,
    quaDialog,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api: require("@/api/pu/prTestRework").default,
      code_api: require("@/api/sy/serialCode").default,
      data: {
        DocNo: "",
        DocDate: this.$commonJs.getToday(),
        Status: 0,
        TestReworkId: 0,
      },
      currentRowId: 0,
      TestReworkDtsDtos: [],
      Status: 0,
      mode: 0,
      viewType: "create",
      isSave: false,
    };
  },
  mounted() {
    this.viewType = this.$route.params.type;
    if (this.$route.params.type === "create") {
      this.getPreviewNo();
    } else if (this.$route.params.type === "edit") {
      this.viewType = 'edit'
      this.editInit(this.$route.params.data);
    }
  },
  methods: {
    toDateStringByFormat(value, format) {
      if (!value) return "";
      let m = this.$moment(value);
      if (!m.isValid()) {
        return "";
      }
      return m.format(format);
    },
    //返回YYYY-MM-DD格式的字符串
    toDateString(value) {
      return this.toDateStringByFormat(value, "YYYY-MM-DD");
    },
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: "warning", message: "请先进行保存再操作" });
        return;
      } else {
        Object.assign(this.$data, this.$options.data.call(this));
        this.$route.params.type = "create";
        this.viewType = "create";
        this.getPreviewNo();
        this.isSave = false;
      }
    },
    handleClick(row){
      this.currentRowId = row.TestReworkDtsId;
      this.$refs.quaDialog.openEdit(row).then(that => {
        that.ThisReworkQuantity = row.ThisReworkQuantity;
        that.TestReworkDtsId = row.TestReworkDtsId;
      })
    },
    update(qua){
      var loading = this.$loading({
        lock: true,
        text: "正在保存...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });

      this.api.info({testReworkId: this.data.TestReworkId}).then(res => {
        loading.close();
        if(res.Code === 0){
          let currentRow = res.Data.TestReworkDtsDtos.filter(item => {
            return this.currentRowId = item.TestReworkDtsId;
          })[0]
          currentRow.ThisReworkQuantity = qua;

          this.editInit(res.Data);

        }
      }).catch(err => {
        loading.close();
      })
    },
    save(){
      var loading = this.$loading({
        lock: true,
        text: "正在保存...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });

      let arr = this.TestReworkDtsDtos.map(item => {
        return {
          TestReworkId: item.TestReworkId,
          TestReworkDtsId: item.TestReworkDtsId,
          WorkDocId: item.WorkDocId,
          ReworkQuantity: item.ReworkQuantity,
        }
      })

      let data = {
        TestReworkDtsList: arr,
        ...this.data
      }
      this.api.save(data).then(res => {
        loading.close();
        if(res.Code === 0){
          this.$message({type: 'success', message: res.Msg})
          this.isSave = true;
          this.api.info(res.Data).then(res1 => {
            if(res1.Code === 0){
              this.editInit(res1.Data);
            }
          })
        }else{
          this.$message({type: 'warning', message: res.Msg})
        }
      }).catch(err => {
        loading.close();
      })
    },
    openDialog(){
        this.$refs.listDialog.openEdit().then(that => {
          
          that.list = [];
          console.log('that', that)
        });
    },
    getPreviewNo(dateTime = "") {
      this.code_api.previewNo("返工单", dateTime).then((res) => {
        if (res.Code == 0) {
          this.mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取返工单号失败");
        }
      });
    },
    selectList(data){
      let arr = [];
      data.forEach(item => {
        let {
          TestReworkId = 0,
          TestReworkDtsId = 0,
          ProductName,
          WorkDocId,
          FailQuantity,
          PassQuantity,
        } = item

        let o = {
          TestReworkId,
          TestReworkDtsId,
          ProductName,
          WorkDocId,
          ReworkQuantity: 0,
          UnReworkQuantity: FailQuantity,
          ThisReworkQuantity: null,
        }

        arr.push(o)
      })

      this.TestReworkDtsDtos = arr;
      
    },
    editInit(data){
      let {
        DocNo,
        DocDate,
        Status,
        TestReworkId,
        TestReworkDtsDtos,
      } = data;

      this.Status = Status;

      if(TestReworkId !== 0){
        this.isSave = true;
      }

      this.data = {
        DocNo,
        DocDate,
        Status,
        TestReworkId,
      }

      this.TestReworkDtsDtos = TestReworkDtsDtos
    },
  }
};
</script>